// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class AnnouncementBar extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (!this.noCookieSet) return

    this.interval = 0
    this.setAttribute('aria-hidden', false)

    this.carousel = this.initialiseCarousel()

    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.offsetHeight}px`,
    )
  }

  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(this.els.close?.element, 'click', this.handleClose)
  }

  initialiseCarousel () {
    if (this.els.slide.elements.length < 2) return

    return new KeenSlider(this.els.slides.element, {
      duration: 0,
      loop: true,
      slides: this.els.slide.elements.length,
      created: () => {
        this.autoplay(true)
      },
      dragStart: () => {
        this.autoplay(false)
      },
      dragEnd: () => {
        this.autoplay(true)
      },
      move: instance => {
        this.els.slide.elements.forEach((slide, index) => {
          slide.setAttribute(
            'aria-hidden',
            index !== instance.details().relativeSlide,
          )
        })
      },
    })
  }

  autoplay (run) {
    clearInterval(this.interval)
    this.interval = setInterval(() => {
      if (run && this.carousel) {
        this.carousel.next()
      }
    }, this.getAutoplayDuration())
  }

  getAutoplayDuration () {
    return parseInt(this.dataset.duration)
  }

  handleClose () {
    window.sessionStorage.setItem(this.cookieName, 'true')

    this.setAttribute('aria-hidden', true)

    document.documentElement.style.setProperty('--Announcement_Height', '0px')
  }

  get noCookieSet () {
    return (
      window.sessionStorage.getItem(this.cookieName) === undefined ||
      window.sessionStorage.getItem(this.cookieName) === null
    )
  }

  get cookieName () {
    return this.dataset.cookie
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
